export function scrollIntoViewIfNeeded(
  element: HTMLElement,
  root?: HTMLElement | null,
  options?: {
    behavior?: ScrollBehavior;
    block?: ScrollLogicalPosition;
    inline?: ScrollLogicalPosition;
    rootMargin?: string;
  }
) {
  if (!element) return;

  // Use IntersectionObserver once and disconnect immediately for memory efficiency
  const observer = new IntersectionObserver(
    ([entry], obs) => {
      if (!entry.isIntersecting) {
        element.scrollIntoView({
          behavior: options?.behavior || 'smooth',
          block: options?.block || 'nearest',
          inline: options?.inline || 'nearest',
        });
      }
      obs.disconnect(); // prevent memory leaks
    },
    { root: root, threshold: 1, rootMargin: options?.rootMargin } // threshold 1 = fully visible
  );

  observer.observe(element);
}
